import "../App.css";
import basket from "../images/basket.png";
import cart from "../images/cart.png";
import {
  tutorial0Maya2,
  tutorial4Maya1,
  tutorial4Maya2,
  tutorialButtonNextPage,
  tutorialButtonPreviousPage,
  tutorialButtonStartLevel,
  tutorialTitle
} from "../strings";

function Tutorial4Maya({ finishTutorial, page, handleNext, handlePrevious }) {

  const maxPages = 3; // Note that the first page has index 0. This means maxPages-1 is the last page.
  const itemSize = 4;

  return (
    <div>
      <div className="tutorial-title">
        {tutorialTitle}
      </div>
      <div className="tutorial-body">
        {page === 0 && 
          <div>
            {tutorial4Maya1}
            <br></br>&nbsp;<br></br>
            <div style={{display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "center"}}>
              <img src={cart} alt="maya-image" style={{ width: 4*(1.5*itemSize)+"dvh", height: (1.5*itemSize)+"dvh", filter: "drop-shadow(0.3svh 0.3svh 0.6svh rgba(0, 0, 0, 0.5))",}}/>
            </div>
          </div>
        }
        {page === 1 && 
          <div style={{display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", width: "100%"}}>
            {tutorial0Maya2}
            <br></br>&nbsp;<br></br>
            <div style={{display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "center"}}>
              <img src={cart} alt="maya-image" style={{ width: 4*itemSize+"dvh", height: itemSize+"dvh", filter: "drop-shadow(0.3svh 0.3svh 0.6svh rgba(0, 0, 0, 0.5))",}}/>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;=&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              <div style={{display: "flex", flexDirection: "column", rowGap: "1dvh", alignItems: "center"}}>{Array.from({length: 4}).map(() => (<img alt="maya" src={basket} style={{width: 4*itemSize+"dvh", height: itemSize+"dvh", filter: "drop-shadow(0.3svh 0.3svh 0.6svh rgba(0, 0, 0, 0.5))"}}/>))}</div>
            </div>
          </div>
        }
        {page === 2 && 
          <div>
            {tutorial4Maya2}
          </div>
        }
      </div>

      {/* Button to start level. */}
      {page === (maxPages-1) && 
        <button
        onClick={finishTutorial}
          className="tutorial-next-button"
        >
        {tutorialButtonStartLevel}
        </button>
      }

      {/* Button to go to previous page. */}
      {page > 0 && 
        <button
          onClick={handlePrevious}
          className="tutorial-previous-button"
        >
        {tutorialButtonPreviousPage}
        </button>
      }

      {/* Button to go to next page. */}
      {page < (maxPages-1) && 
        <button
          onClick={handleNext}
          className="tutorial-next-button"
        >
        {tutorialButtonNextPage}
        </button>
      }
    </div>
  );
}

export default Tutorial4Maya;
